
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import ConfiguracaoData from "./ConfiguracaoData";

export default {
  name: "app-configuracoes-update",
  data() {
    return {
      configuracao: new ConfiguracaoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getConfiguracao(id_configuracao) {
      try {
        const { data } = await this.$http.post("/configuracoes/find", {
          id: id_configuracao,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id;

        this.setLoading(true);

        const configuracao = await this.getConfiguracao(codigo);

        this.setLoading(false);

        if (!configuracao.id || configuracao == null) {
          this.$router.push({ name: "configuracoesLista" });
          return this.$toast.error("Configuração não encontrada!");
        }

        this.configuracao = new ConfiguracaoData(configuracao);
      } catch {
        return;
      }
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
